import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getOrderTypeContent,
  getCatAlign,
  getalldata,
  savelocaldata,
  getLogoContent,
  getmacAdrs,
  getdata,
  deleteAllRows,
} from "../api/service";

function OrderTypePage() {
  const navigate = useNavigate();
  const [bannerUrl, setBannerUrl] = useState("");
  const [loading, setLoading] = useState(true);
  // const [isOffline, setIsOffline] = useState(false);
  const [dateTime, setDateTime] = useState(new Date());
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(new Date());
    }, 1000); // updates every second

    return () => clearInterval(timer); // cleanup on unmount
  }, []);

  const companyName = localStorage.getItem("CompanyName");
  const storeName = localStorage.getItem("StoreName");

  console.log(companyName);
  console.log(storeName);

  useEffect(() => {
    async function fetchBanner() {
      try {
        setLoading(true);
        const CompId = localStorage.getItem("compId");
        const data = await getOrderTypeContent(CompId);
        console.log("Order Type Banner API:", data);

        // Extract banner image from API
        let contentArray = Array.isArray(data?.homeContents)
          ? data.homeContents
          : [];

        // Filter active ones and find one with a valid image
        const activeBanners = contentArray.filter(
          (item) => item.isActive !== false && item.url,
        );

        // Use first available active banner
        const banner =
          activeBanners.length > 0
            ? activeBanners[0].url
            : "https://img.freepik.com/free-/-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89595.jpg?w=1060";

        setBannerUrl(banner);
      } catch (err) {
        console.error("Failed to fetch order type banner:", err);
        setBannerUrl(
          "https://bizdomfs.blob.core.windows.net/post-image/ea330369-debe-4fe6-848a-e40ef195a052.jfif",
        );
      } finally {
        setLoading(false);
      }
    }

    fetchBanner();
  }, []);

  const [isTopLayout, setIsTopLayout] = useState(true);

  // const handleOrderType = async (type) => {
  //   const CompId = localStorage.getItem("compId");
  //   const StoreId = localStorage.getItem("StoreId");

  //   // ✔ Correct type checking
  //   let typeId = type === "Dine In" ? 1 : 2;

  //   // Get Category Alignment Settings
  //   const settings = await getCatAlign(CompId);

  //   if (settings?.status === 200) {
  //     let activeAlign = true;

  //     if (Array.isArray(settings.aligns) && settings.aligns.length > 0) {
  //       const selectedAlign =
  //         settings.aligns.find((a) => a.isActive) || settings.aligns[0];

  //       activeAlign = !!selectedAlign.isActive;
  //       setIsTopLayout(activeAlign);
  //     }

  //     // ✔ Fetch all data
  //     const response = await getalldata(CompId, StoreId, typeId);
  //     console.log("Fetched All Data:", response);

  //     // ✔ Delete existing rows
  //     const delResponse = await deleteAllRows();
  //     console.log("Deleted All Rows:", delResponse);

  //     if (delResponse.Status === 200) {
  //       const savedata = await savelocaldata(response);
  //       console.log("Saved Result:", savedata);
  //     }

  //     // Save type + layout to localStorage
  //     localStorage.setItem("orderType", type);
  //     localStorage.setItem("ordertypeId", typeId);

  //     localStorage.setItem("layoutPosition", activeAlign ? "top" : "side");

  //     // Navigate with query params
  //     navigate(`/about?type=${type}&showcard=${activeAlign}`);
  //   }
  // };

  const handleOrderType = async (type) => {
    try {
      setLoading(true);
      const startTime = Date.now();
      const getmac = localStorage.getItem("device_mac");
      console.log("Local MAC:", getmac);
      localStorage.removeItem("lastActiveCategory");

      // ✅ Catch network errors specifically here
      let macData;

      macData = await getmacAdrs(getmac);

      const macInfo = macData.macAdd?.[0];

      if (macInfo) {
        localStorage.setItem("StoreId", macInfo.storeId);
        localStorage.setItem("macAdrs", macInfo.macAddress);
        localStorage.setItem("compId", macInfo.companyId);

        const data = await getdata(macInfo.companyId, macInfo.storeId);
        console.log("Fetched Data:", data);

        if (data?.datas?.length > 0) {
          localStorage.setItem("CompanyName", data.datas[0].companyName);
          localStorage.setItem("StoreName", data.datas[0].storeName);
          console.log(data?.datas);
        }

        const CompId = localStorage.getItem("compId");
        const StoreId = localStorage.getItem("StoreId");

        // ✅ Fetch logo
        let logoUrl = localStorage.getItem("logo");
        if (!logoUrl || logoUrl === "null" || logoUrl === "undefined") {
          try {
            const logoData = await getLogoContent(CompId);
            console.log("Logo API Response:", logoData);
            if (logoData?.logo?.[0]?.url) {
              logoUrl = logoData.logo[0].url;
            } else {
              logoUrl =
                "https://bizdomfs.blob.core.windows.net/post-image/139a753e-0b57-41e3-ace6-9d2c4a866d24.png";
            }
            localStorage.setItem("logo", logoUrl);
            setLogo(logoUrl);
          } catch (logoError) {
            console.error("Failed to fetch logo:", logoError);
            logoUrl =
              "https://bizdomfs.blob.core.windows.net/post-image/139a753e-0b57-41e3-ace6-9d2c4a866d24.png";
            localStorage.setItem("logo", logoUrl);
          }
        }

        // ✅ Order type
        let typeId = type === "Dine In" ? 1 : 2;

        // ✅ Category alignment settings
        const settings = await getCatAlign(CompId);

        if (settings?.status === 200) {
          let activeAlign = true;

          if (Array.isArray(settings.aligns) && settings.aligns.length > 0) {
            const selectedAlign =
              settings.aligns.find((a) => a.isActive) || settings.aligns[0];
            activeAlign = !!selectedAlign.isActive;
            setIsTopLayout(activeAlign);
          }

          // ✅ Fetch all data
          const response = await getalldata(CompId, StoreId, typeId);
          console.log("Fetched All Data:", response);

          // ✅ Delete existing rows
          const delResponse = await deleteAllRows();
          console.log("Deleted All Rows:", delResponse);

          if (delResponse.Status === 200) {
            const savedata = await savelocaldata(response);
            console.log("Saved Result:", savedata);
          }

          // ✅ Save to localStorage
          localStorage.setItem("orderType", type);
          localStorage.setItem("ordertypeId", typeId);
          localStorage.setItem("layoutPosition", activeAlign ? "top" : "side");

          // ✅ Navigate
          navigate(`/about`, {
            state: {
              type: type,
              showcard: activeAlign,
              logoUrl: logoUrl,
            },
          });
        }
      }

      // ✅ Minimum loading duration
      const elapsed = Date.now() - startTime;
      const minDuration = 1000;
      if (elapsed < minDuration)
        await new Promise((r) => setTimeout(r, minDuration - elapsed));
    } catch (error) {
      console.error("Error during checkout:", error);
    } finally {
      setLoading(false);
    }
  };

  const Logo = localStorage.getItem("logo");

  if (loading) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
        <div className="relative flex items-center justify-center">
       <div className="w-24 h-24 border-4 border-[#f23c97] border-t-transparent rounded-full animate-spin"></div>
          <img
            src={
              Logo ||
              "https://bizdomfs.blob.core.windows.net/post-image/abfd00c4-1ece-4ee2-ac5a-3750cd351dbd.png"
            }
            alt="Logo"
            className="absolute w-12 h-12"
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex flex-col h-screen w-full text-white relative"
      style={{ backgroundImage: "radial-gradient(#f50000, #181818d4)" }}
    >
      {/* 🏢 Company & Store Info */}
      {/* <div className="absolute top-4 right-6 flex items-center gap-4 text-right z-10">
        <h2 className="text-lg font-bold tracking-wide text-black">
          {companyInfo.CompanyName || "Loading Company..."}
        </h2>

        <p className="text-lg opacity-90 text-black">
          {companyInfo.StoreName || "Loading Store..."}
        </p>

        <p className="text-sm text-black">
          {dateTime.toLocaleString("en-IN", {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })}
        </p>
      </div> */}

      {/* 🔙 Back Button */}
      <button
        onClick={() => navigate("/")}
        style={{ zoom: "1.3" }}
        className="absolute top-4 left-4 flex items-center gap-2 bg-white text-red-700 px-3 py-2 rounded-full shadow-md hover:bg-gray-200 z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
        <span className="font-medium">Back</span>
      </button>

      {/* Banner Section with overlayed text */}
      <div
        className="relative w-full bg-black shadow-lg"
        style={{ maxHeight: "825px" }}
      >
        <img
          src={bannerUrl}
          alt="Restaurant Banner"
          className="w-full h-full object-cover"
        />

        {/* 🏷️ Left-side Info Overlay */}
        <div
          className="absolute top-1/2 transform  -translate-y-1/2 
             flex flex-col items-center justify-center text-white  
             rounded-3xl px-14 py-10   min-w-[600px] min-h-[320px]"
        >
          {/* 🏢 Company Info */}
          <h2 className="text-4xl font-bold tracking-wide">
            <i>
              <span className="text-5xl" style={{ fontSize: "70px" }}>
                {" "}
                Welcome
              </span>{" "}
              <span> to</span>
              <span className="text-5xl" style={{ fontSize: "70px" }}>
                {" "}
                {companyName}
              </span>{" "}
            </i>
          </h2>
          {/* <p className="text-lg  opacity-90 mb-5">{storeName}</p> */}

          {/* ⏰ Time */}
          <div className="flex items-baseline gap-2">
            <h1
              style={{ fontSize: "110px" }}
              className="text-7xl font-extrabold leading-none"
            >
              {dateTime.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
              })}
            </h1>
            <span className="text-2xl font-semibold ml-1">
              {
                dateTime
                  .toLocaleTimeString("en-US", { hour12: true })
                  .split(" ")[1]
              }
            </span>{" "}
            <div className="font-bold">
              <h3 className="font-bold text-white">
                | V-{process.env.REACT_APP_VERSION}
              </h3>
            </div>
          </div>

          {/* 📅 Date */}
          <p className="text-xl mt-4">
            <i>
              {dateTime.toLocaleString("en-US", {
                month: "short",
                weekday: "long",
                day: "numeric",
              })}
            </i>
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col items-center justify-center flex-1 p-6">
        <h1
          className="text-4xl md:text-6xl font-extrabold mb-12 drop-shadow-lg text-center"
          style={{ color: "white" }}
        >
          Choose Your Order Type
        </h1>

        <div className="flex flex-col md:flex-row gap-10">
          {/* Dine In */}
          <button
            onClick={() => handleOrderType("Dine In")}
            className="w-72 h-52 bg-white text-red-700 font-extrabold text-4xl rounded-3xl shadow-2xl 
             flex flex-col items-center justify-center transform hover:scale-105 
             transition duration-300"
          >
            <img
              src="https://img.freepik.com/premium-vector/dining-room-icon-simple-vector-illustration_404166-593.jpg?w=1060"
              alt="Dine In"
              className="w-24 h-24 object-contain"
            />
            <span className="mt-3">Dine In</span>
          </button>

          {/* Take Away */}
          <button
            onClick={() => handleOrderType("Take Away")}
            className="w-72 h-52 bg-white text-red-700 font-extrabold text-4xl rounded-3xl shadow-2xl 
                       flex flex-col items-center justify-center transform hover:scale-105 
                       transition duration-300"
          >
            <img
              src="https://img.freepik.com/premium-vector/food-delivery-paper-bag-flat-illustration_124715-577.jpg?w=1060"
              alt="Take Away"
              className="w-24 h-24 object-contain"
            />
            <span className="mt-3">Take Away</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderTypePage;
